import { SimpleModalService } from '../../../shared/dialogs/simple-modal.service'
import { Component, forwardRef, Inject, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import _ from 'lodash'
import { AuthContextStorageService } from '../../../core/auth/auth-context-storage.service'
import { HeaderMenuService } from '../services/header-menu.service'
import { NotificationService } from '../services/notification.service'
import { GoogleAnalyticsService } from '../../../core/monitoring/google-analytics.service'
import { AuthService } from '../../../core/auth/auth.service'
import { CommonService }from '../../../core/services/common.service'
import { UserContextStorageService } from '../../auth/user-context/user-context-storage.service'
import {DialogService} from '../../../core/services/dialog.service'
import { HelpdeskDialogComponent } from '../dialogs/helpdesk/helpdesk-dialog.component'
import { Subscription } from 'rxjs'
import { ErrorService } from '../../../core/services/error.service'
import { Store } from '@ngrx/store'
import { selectProject, selectProjects, selectUserName } from '../../auth/user-context/state/user-context.selectors'
import { selectDepartments, selectHeaderComponentState } from '../state/main-view.selectors'
import { MainViewActions } from '../state/action-types'
import { CommandPaletteActions } from '../state/command-palette.action-types'
import { StoreKeysEnum } from '../../../store/store-keys'
import { HeaderActions } from './state/action-types'
import { selectPerfectScrollbarState } from '../../../shared/ui/perfect-scrollbar/state/perfect-scrollbar.selectors'
import { selectHeaderData } from './state/header.selectors'

@Component({
    selector: 'ca-header',
    templateUrl: './header.html',
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {

    contractBulkOperationsLoading = false
    editCuzkSettings: boolean
    filterCriteria: any
    filterCriteriaRead: any
    public psFeatureKey = StoreKeysEnum.HeaderComponent + ':unread'
    public psFeatureKey2 = StoreKeysEnum.HeaderComponent + ':read'
    perfectScrollbarKey = 'unread'
    perfectScrollbarKeyRead = 'read'
    menu: Array<any>
    notificationsCount: number
    notificationsReadCount: number
    schemaFilter = ''
    projectMenu = false
    showBulkOperations = false
    showNoNotification = false
    showNotifications = false
    showNotificationsRead = false
    userMenuOpened = false
    mainMenuOpened = false
    mainMenuLinkClicked = false
    projects: any[]
    customerName: string
    project: any

    browserTestingURL: string
    isUserAdmin: boolean

    breadcrumbsPath: string
    selectedDepartment: any
    notificationsLoading: boolean
    notificationsReadLoading: boolean
    notifications: any[]
    notificationsRead: any[]
    departments: any[]

    #selectProject: Subscription
    #selectProjects: Subscription
    #selectUserName: Subscription
    #selectHeaderComponentState: Subscription
    #selectDepartments: Subscription

    #psState: Subscription
    #psStateRead: Subscription
    #headerState: Subscription
    #headerStateRead: Subscription

    constructor(@Inject(Store) private store: Store,
                @Inject(Router) private router: Router,
                @Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService,
                @Inject(AuthService) private authService: AuthService,
                @Inject(CommonService) private commonService: CommonService,
                @Inject(DialogService) private dialogService: DialogService,
                @Inject(ErrorService) private errorService: ErrorService,
                @Inject(GoogleAnalyticsService) private googleAnalyticsService: GoogleAnalyticsService,
                @Inject(HeaderMenuService) private headerMenuService: HeaderMenuService,
                @Inject(forwardRef(() => NotificationService)) private notificationService: NotificationService,
                @Inject(SimpleModalService) private simpleModalService: SimpleModalService,
                @Inject(UserContextStorageService) private userContextStorageService: UserContextStorageService) {
        this.#selectProjects = this.store.select(selectProjects).subscribe(data => {
            this.projects = data
        })

        this.#selectUserName = this.store.select(selectUserName).subscribe(data => {
            this.customerName = data
        })

        this.#selectProject = this.store.select(selectProject).subscribe(data => {
            this.project = data
        })

        this.#selectHeaderComponentState = this.store.select(selectHeaderComponentState).subscribe(data => {
            this.notificationsCount = data.unreadNotificationsCount
            this.breadcrumbsPath = this.displayBreadCrumbs(data.breadcrumbs)
            this.notificationsReadCount = data.notificationsCount
            this.selectedDepartment = data.selectedDepartment
        })

        this.#psState = this.store.select(selectPerfectScrollbarState(this.perfectScrollbarKey)).subscribe(data => {
            this.notificationsLoading = data.loadState
        })

        this.#psStateRead = this.store.select(selectPerfectScrollbarState(this.perfectScrollbarKeyRead)).subscribe(data => {
            this.notificationsReadLoading = data.loadState
        })

        this.#headerState = this.store.select(selectHeaderData(this.perfectScrollbarKey)).subscribe(data => {
            this.filterCriteria = data.filterCriteria
            this.notifications = data.itemCollection
        })

        this.#headerStateRead = this.store.select(selectHeaderData(this.perfectScrollbarKeyRead)).subscribe(data => {
            this.filterCriteriaRead = data.filterCriteria
            this.notificationsRead = data.itemCollection
        })

        this.#selectDepartments = this.store.select(selectDepartments).subscribe(data => {
            this.departments = data
        })
    }

    ngOnInit(): void {
        this.store.dispatch(HeaderActions.initStore({
            key: this.perfectScrollbarKey,
            alreadyRead: false
        }))
        this.store.dispatch(HeaderActions.initStore({
            key: this.perfectScrollbarKeyRead,
            alreadyRead: true
        }))

        this.editCuzkSettings = this.authContextStorageService.hasPermission('edit_cuzk_settings')
        this.menu = this.headerMenuService.getHeaderMenuItems()
        this.browserTestingURL = this.getBrowserTestingUrl()
        this.isUserAdmin = this.authContextStorageService.isUserAdmin()
    }

    ngOnDestroy(): void {

        this.#selectProjects?.unsubscribe()
        this.#selectUserName?.unsubscribe()
        this.#selectProject?.unsubscribe()
        this.#selectHeaderComponentState?.unsubscribe()
        this.#psState?.unsubscribe()
        this.#psStateRead?.unsubscribe()
        this.#headerState?.unsubscribe()
        this.#headerStateRead?.unsubscribe()
        this.#selectDepartments?.unsubscribe()

        this.store.dispatch(HeaderActions.reset({
            key: this.perfectScrollbarKey
        }))
        this.store.dispatch(HeaderActions.reset({
            key: this.perfectScrollbarKeyRead
        }))
    }

    detailNotification(notification): void {
        this.readNotification(notification)
        const item = _.cloneDeep(notification)

        switch (item.notification.notificationType) {
            case 'CONTRACT':
                // TEMP: workaround CA-15188 - removed contracts filter click
                // TODO: In future notifications should have list of contracts from BE
                if (item.notification.contractInvalidDate) {
                    item.notification.detail = item.notification.perex
                    this.notificationService.commonNotificationDetail(item)
                }
                this.notificationService.contractNotificationDetail(item)
                break
            case 'INFO':
                this.notificationService.commonNotificationDetail(item)
                break
            case 'ESIGN':
                if (item.notification.contractId) {
                    this.notificationService.contractNotificationDetail(item)
                }
                else if (item.notification.detail) {
                    this.notificationService.commonNotificationDetail(item)
                }
                break
            case 'CONTRACT_PAYMENT':
                this.notificationService.paymentNotificationDetail()
                break
        }
    }

    hideNotifications(): void {
        if (this.showNoNotification) {
            this.showNoNotification = false
        }

        if (this.showNotifications) {
            this.showNotifications = false
        }

        if (this.showNotificationsRead) {
            this.showNotificationsRead = false
        }
    }

    changeDepartment(department): void {
        this.store.dispatch(MainViewActions.setSelectedDepartment({
            department: department
        }))

        this.googleAnalyticsService.logEvent('header', 'department_change', department.name)

        this.projectMenu = !this.projectMenu

        this.goToLandingPageWithFullReload()
    }

    changeProject(projectKey): void {
        this.projectMenu = !this.projectMenu
        this.authService.switchProject(projectKey).then(() => {
            this.store.dispatch(HeaderActions.reset({
                key: this.perfectScrollbarKey
            }))
            this.store.dispatch(HeaderActions.reset({
                key: this.perfectScrollbarKeyRead
            }))
            this.store.dispatch(MainViewActions.setSelectedDepartment({
                department: null
            }))

            this.googleAnalyticsService.logEvent('header', 'project_change', projectKey)

            this.goToLandingPageWithFullReload()
        })
    }

    logBreadcrumbsClick(event: MouseEvent): void {
        // Handle Angular Router navigation for breadcrumb links
        const target = event.target as HTMLElement
        const anchor = target.closest('a')

        if (anchor && anchor.getAttribute('href')) {
            const href = anchor.getAttribute('href')
            const breadcrumbLabel = (anchor.textContent || '').trim() || href

            this.googleAnalyticsService.logEvent('header', 'breadcrumb_click', breadcrumbLabel)
            this.googleAnalyticsService.setNavigationSource('breadcrumb')

            // Prevent default browser navigation (full page reload)
            event.preventDefault()

            // Use Angular Router for SPA navigation
            this.router.navigateByUrl(href)
        } else {
            this.googleAnalyticsService.logEvent('header', 'breadcrumb_click', 'unknown')
        }
    }

    logUserMenuClick(label): void {
        this.googleAnalyticsService.logEvent('header', 'user_menu', label)
    }

    mainMenuLinkClick(item: { route: string; text: string }): void {
        this.mainMenuLinkClicked = true
        this.googleAnalyticsService.logEvent('header', 'main_menu_click', item?.text || 'unknown')
        this.googleAnalyticsService.setNavigationSource('hamburger')
    }

    mainMenuToggle(): void {
        this.mainMenuOpened = !this.mainMenuOpened
        this.mainMenuLinkClicked = false
        if (this.mainMenuOpened === true) {
            this.googleAnalyticsService.logEvent('header', 'main_menu', 'open')
        }
    }

    readAll(): void {
        this.commonService.showActionProgress('Probíhá zpracování oznámení')
        this.notificationService.readAll().subscribe(() => {
            this.hideNotifications()
            this.store.dispatch(MainViewActions.setReadNotificationsCount({
                count: this.notificationsCount + this.notificationsReadCount
            }))
            this.store.dispatch(MainViewActions.resetUnreadNotificationsCount())

            this.filterAll()

            this.commonService.hideActionProgress()
        }, (error) => {
            this.commonService.hideActionProgress()
            this.errorService.onErrorResponseAlertUser(
                error,
                'Nepodařilo se aktualizovat oznámení, kontaktujte prosím podporu.')
        })
        this.googleAnalyticsService.logEvent('header', 'notifications', 'read_all')
    }

    readNotification(notification): void {
        if (!notification.alreadyRead) {
            this.notificationService.read(notification.notificationId).subscribe(
                () => {
                    this.store.dispatch(MainViewActions.setUnreadNotificationsCount({
                        count: this.notificationsCount - 1
                    }))
                    this.store.dispatch(MainViewActions.setReadNotificationsCount({
                        count: this.notificationsReadCount + 1
                    }))

                    this.filterAll()
                },
                (error) => {
                    this.errorService.onErrorResponseAlertUser(
                        error,
                        'Nepodařilo se aktualizovat oznámení, kontaktujte prosím podporu.')
                }
            )
        }
    }

    toggleNoNotifications(): void {
        this.showNoNotification = !this.showNoNotification
    }

    toggleNotifications(): void {
        if (this.showNotificationsRead === false) {
            this.showNotifications = !this.showNotifications
        } else {
            this.showNotificationsRead = false
        }
        if (this.showNotifications === true) {
            this.googleAnalyticsService.logEvent('header', 'notifications', 'open_new', this.notificationsCount)
        }
    }

    toggleNotificationsRead(): void {
        this.showNotificationsRead = !this.showNotificationsRead
        if (this.showNotificationsRead === true) {
            this.googleAnalyticsService.logEvent('header', 'notifications', 'open_read', this.notificationsReadCount)
        }
    }

    getBrowserTestingUrl(): string {
        // @ts-ignore
        let url = CA_CONFIG.BACKEND_OPTIONS.browserTestingUrl

        // If running from different domain we need to add query parameter.
        // On same domain user's e-mail is handled by Intercom cookie.
        if (!_.endsWith(window.location.hostname, 'cleverassets.cz') && this.userContextStorageService.getUser()) {
            url += '?' + this.obfuscateEmail(this.userContextStorageService.getUser().username)
        }
        return url
    }

    showCuzkLogin(): void {
        this.dialogService.showCuzkLoginDialog('HEADER')
    }

    showHelpdesk(): void {
        this.simpleModalService.addModal(HelpdeskDialogComponent)
    }

    public performLogout(): void {
        this.authService.logout()
    }

    public openCommandPalette(): void {
        this.googleAnalyticsService.logEvent('command_palette', 'open', 'header_click')
        this.store.dispatch(CommandPaletteActions.openCommandPalette())
    }

    getNotificationClass = (notification): string => this.notificationService.getClass(notification)

    private filterAll(): void {
        this.store.dispatch(HeaderActions.filter({
            key: this.psFeatureKey
        }))
        this.store.dispatch(HeaderActions.filter({
            key: this.psFeatureKey2
        }))
    }

    private obfuscateEmail(email: string): string {
        const base64 = btoa(email).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
        return base64.split('').reverse().join('')
    }

    private displayBreadCrumbs(breadcrumbsHistory: any[]): string {
        let bcArray = []
        breadcrumbsHistory.forEach(bc => {
            if (bc.state && bc.title) {
                if (bc === _.last(breadcrumbsHistory)) {
                    bcArray.push(bc.title)
                } else {
                    // DEV-1656: returnUrl is the full url of the page as the user actually left it
                    // (incl. context query params); bc.url is the lossy rebuilt back-link (DEV-797).
                    const href = bc.returnUrl || bc.url || '#'
                    bcArray.push('<a href="' + href + '">' + bc.title + '</a>')
                }
            } else if (bc.title) {
                bcArray.push(bc.title)
            }
        })

        if (breadcrumbsHistory.length > 0) {
            return '<a class="fa fa-home" href="/landingPage" title="Přejít na úvodní stránku.">'
                + '<span class="hidden">Přejít na úvodní stránku.</span></a> '
                + '<span class="fa fa-angle-right"></span> '
                + bcArray.join(' <span class="fa fa-angle-right"></span> ')
        } else {
            return null
        }
    }

    /**
     * Přepnutí projektu i střediska potřebuje aplikaci znovu inicializovat, ne jen přenavigovat —
     * proto tvrdé načtení. Dřív to bylo `router.navigate()` a v jeho `then()` `window.location.reload()`,
     * tedy **dvě** načtení stránky za sebou.
     *
     * To škodilo (DEV-2297): každé načtení projde guardem, ten zavolá `onStartup()` a ten obnoví
     * access token — a každá úspěšná obnova na straně `ca-auth` zrotuje refresh token a předchozí
     * zneplatní. Druhé načtení přišlo dřív, než se první obnova vrátila (trvá ~330 ms), takže ji
     * zbořilo. Server měl nový token, prohlížeč zůstal se starým a od té chvíle dostával na každou
     * obnovu 401 → odhlášení → `/login`. Doloženo Playwright trace, viz ticket.
     *
     * Vybrané středisko tím neztratíme — ukládá ho `saveLastSelectedDepartment` do `localStorage`
     * synchronně už při dispatchi akce, tedy před touto navigací.
     */
    private goToLandingPageWithFullReload(): void {
        window.location.href = '/landingPage'
    }
}
